import React, { useState, useEffect } from 'react'
import { ModalBody } from 'react-bootstrap'
import { useMutation, useQuery } from 'react-query'
import { Modal, ModalHeader } from 'reactstrap'
import { postPaymentMethods, showPaymentMethod, updatePaymentMethod } from '../../MyApi/paymentmethods'
import { toast } from 'react-toastify'
import i18next from "i18next"

const AddPaymentModal = ({ isOpen, toggle ,refetch, modalMode, modalId }) => {
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    description: '',
    is_active:1 ,
    sort_order:""
  })
  const [selectedLangCode, setSelectedLangCode] = useState(i18next.language)

  const { data: showPaymentData } = useQuery(
    ["showPaymentMethod", modalId],
    () => showPaymentMethod(modalId, selectedLangCode),
    { enabled: !!modalId && modalMode === "edit" },
  );

  const mutation = useMutation({
    mutationKey: ['addpaymentmethod'],
    mutationFn: postPaymentMethods,
    onSuccess: (data) => {
      toast.success(data.message || 'تمت الإضافة بنجاح')
      toggle?.()
      refetch()
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'حدث خطأ')
    },
  })

  const mutationUpdate = useMutation({
    mutationKey: ['updatePaymentMethod'],
    mutationFn: (postData) => updatePaymentMethod(postData, modalId),
    onSuccess: (data) => {
      toast.success(data.message || 'تم التحديث بنجاح')
      toggle?.()
      refetch()
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'حدث خطأ')
    },
  })

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked ? 1 : 0 : value
    }))
  }

  const handleSelectedCodeLang = (e) => {
    setSelectedLangCode(e.target.value);
  };

  useEffect(() => {
    if (modalMode === "edit" && showPaymentData) {
      const paymentMethod = showPaymentData?.data?.payment_method || {};
      setFormData({
        name: paymentMethod.name || '',
        code: paymentMethod.code || '',
        description: paymentMethod.description || '',
        is_active: paymentMethod.is_active ? 1 : 0,
        sort_order: paymentMethod.sort_order || ""
      });
    } else if (modalMode === "add") {
      setFormData({
        name: '',
        code: '',
        description: '',
        is_active: 1,
        sort_order: ""
      });
    }
  }, [modalMode, showPaymentData, modalId]);

  const handlePostRequest = () => {
    if (!formData.name || !formData.code) {
      toast.warning('من فضلك املأ الحقول المطلوبة')
      return
    }

    if (modalMode === "edit") {
      const dataToSend = {
        ...formData,
        lang: selectedLangCode,
        _method: "PUT"
      };
      mutationUpdate.mutate(dataToSend);
    } else {
      mutation.mutate({
        ...formData,
        is_active: 1,
        is_cod: 1,
      })
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <h5>{modalMode === "edit" ? "تعديل طريقة دفع" : "إضافة طريقة دفع جديدة"}</h5>
        <p className="des text-start">
          {modalMode === "edit" ? "تعديل طريقة دفع للمنصة" : "تكوين طريقة دفع جديدة للمنصة"}
        </p>
      </ModalHeader>

      <ModalBody className='add'>
        {modalMode === "edit" && (
          <div className="mb-3">
            <label className="form-label">اختيار اللغة</label>
            <select
              className="form-control"
              value={selectedLangCode}
              onChange={handleSelectedCodeLang}
            >
              <option value="ar">العربية</option>
              <option value="en">الإنجليزية</option>
            </select>
          </div>
        )}

        <div className="mb-3 ">
          <label className="form-label">اسم طريقة الدفع</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">النوع</label>
          <input
            type="text"
            name="code"
            className="form-control"
            value={formData.code}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">مزود الخدمة</label>
          <input
            type="text"
            name="description"
            className="form-control"
            value={formData.description}
            onChange={handleChange}
          />
        </div>     

        
        <div className="mb-3">
          <label className="form-label">الترتيب</label>
          <input
            type="text"
            name="sort_order"
            className="form-control"
            value={formData.sort_order}
            onChange={handleChange}
          />
        </div>  
        <div className="mb-3">
          <label className="form-label">حالة طريقة الدفع</label>
          <label className="switch">
            <input
              type="checkbox"
              checked={formData.is_active === 1}
              onChange={handleChange}
              name="is_active"
            />
            <span className="slider round"></span>
          </label>
        </div>

        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-primary"
            onClick={handlePostRequest}
            disabled={mutation.isLoading || mutationUpdate.isLoading}
          >
            {mutation.isLoading || mutationUpdate.isLoading 
              ? 'جاري المعالجة...' 
              : (modalMode === "edit" ? 'تحديث طريقة الدفع' : 'إضافة طريقة دفع')}
          </button>

          <button className="btn btn-white" onClick={toggle}>
            إلغاء
          </button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default AddPaymentModal
